/* eslint-disable import/prefer-default-export */
export const APPEND_WORKSHOP_FOR_DATE_VISITS = 'APPEND_WORKSHOP_FOR_DATE_VISITS';
export const GET_WORKSHOP_FOR_DATE_VISITS = 'GET_WORKSHOP_FOR_DATE_VISITS';
